"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var o=require("../toColor/toColor.js");exports.getColorByCoordinates=function(r,e,t,s,l){var u=e/s*100,i=t/l*100;return o.toColor("hsb",{h:r,s:u,b:100-i})};
